import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StreamingLeftNavigationService {
    private readonly conversationShowed$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private readonly conversationSessionSelected$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(
        null
    );

    showConversation(): void {
        // console.log('🚀 [LeftNavigationService] Starting new conversation');
        // console.log(
        //     '🔍 [LeftNavigationService] Current subscribers count:',
        //     (this.conversationShowed$ as any).observers?.length || 0
        // );
        this.conversationShowed$.next(true);
        // console.log('🔍 [LeftNavigationService] Emitted true, current value:', this.conversationShowed$.value);
    }

    selectConversationSession(sessionId: number | null): void {
        this.conversationSessionSelected$.next(sessionId);
    }

    hideConversation(): void {
        this.conversationShowed$.next(false);
    }

    conversationShowedChange(): Observable<boolean> {
        return this.conversationShowed$.asObservable();
    }

    conversationSessionSelectedChange(): Observable<number | null> {
        return this.conversationSessionSelected$.asObservable();
    }

    // Backward compatibility methods - delegate to conversation methods
    showChat(): void {
        this.showConversation();
    }

    hideChat(): void {
        this.hideConversation();
    }

    selectChatSession(sessionId: number | null): void {
        this.selectConversationSession(sessionId);
    }

    chatShowedChange(): Observable<boolean> {
        return this.conversationShowedChange();
    }

    chatSessionSelectedChange(): Observable<number | null> {
        return this.conversationSessionSelectedChange();
    }
}
